{
  "version": 1,
  "asset_id": "fdf91273-59a0-4a9d-bf73-e12cff19f188",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/fdf91273-59a0-4a9d-bf73-e12cff19f188/team-640.avif",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/fdf91273-59a0-4a9d-bf73-e12cff19f188/team-640.avif",
  "original_filename": "team-640.avif",
  "size": 12450,
  "content_type": "image/avif",
  "created_at": "2026-07-25T02:27:01Z"
}
